import React, {useState, useEffect, useContext} from 'react';
import AddPhotoView from './AddPhotoView';
import api from '../../../../axios.config';
import Spinner from '../../../Spinner/Spinner';
import swal from 'sweetalert';
import {getFacture, getPlaceNameHistory, getPlaceNameAll, getChantierIdInfo} from '../../../../services/MadricService';
import {useLocation} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {MadricContext} from '../../../../Context/MadricContext';

/**
 * Permet l'ajout des médias
 * @param {*} props props
 * @return {JSX}
 */
function AddPhoto(props) {
  const [isLoading, setIsLoading] = useState(false);

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    let month = today.getMonth() + 1;
    let day = today.getDate();

    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;

    return `${year}-${month}-${day}`;
  };

  const [form, setForm] = useState({
    file: null,
    montant: 0,
    note: '',
    chantier: [],
    factureNameForm: 0,
    selectedDate: getCurrentDate(),
    extra1: false,
    extra2: false,
    extra3: false,
    avancement: false,
  });

  const [errors, setErrors] = useState({});
  const [orientation, setOrientation] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const {setWhatToShow, setProjectInfo} = useContext(MadricContext);

  const [factureName, setFactureName] = useState([]);
  const [placeName, setPlaceName] = useState([]);
  const [checkedChantier, setCheckedChantier] = useState(false);

  let checkedChantierAfterRender = false;

  useEffect(() => {
    fetchFactures();
    fetchPlaces();
    fetchPlaceId();
  }, []);

  const handleChantierCheckBox = () => {
    setCheckedChantier((prevState) => (!prevState));
    checkedChantierAfterRender = !checkedChantier;
    fetchPlaces();
  };


  /**
   * Va chercher la liste des factures
   */
  async function fetchFactures() {
    await getFacture().then((res) => {
      setFactureName(res.map((item) => ({value: item.id, label: item.name})));
    });
  }

  /**
   * Va chercher la liste des chantiers
   */
  async function fetchPlaces() {
    if (checkedChantierAfterRender) {
      setIsLoading(true);
      const res = await getPlaceNameAll();
      setIsLoading(false);
      setPlaceName(res);
    } else {
      setIsLoading(true);
      const res = await getPlaceNameHistory();
      setIsLoading(false);
      setPlaceName(res);
    }
  }

  /**
   * Permet de recevoir le id de la place
   */
  async function fetchPlaceId() {
    const res = await getChantierIdInfo(location.state.id);
    setForm({
      ...form,
      chantier: [{label: res.name, value: res.id}],
    });
  }

  const openModal = () => {
    swal('Votre photo a été enregistré');
  };


  const handleFileChange = (event) => {
    if (event.target.files !== null) {
      const imageFile = Array.from(event.target.files);
      setForm({
        ...form,
        file: imageFile,
      });
    }
  };

  useEffect(() => {
    if (form.file !== null) {
      setOrientation([]);
      form.file.forEach(getOrientation);
    }
  }, [form.file]);


  /**
   * Permet de savoir l'orientation de la photo
   * @param {*} singleFile singleFile
   */
  function getOrientation(singleFile) {
    const reader = new FileReader();

    reader.onload = function(event) {
      const view = new DataView(event.target.result);

      if (view.getUint16(0, false) !== 0xFFD8) {
        setOrientation((oldArray) => [...oldArray, -2]);
        return;
      }

      const length = view.byteLength;
      let offset = 2;

      while (offset < length) {
        const marker = view.getUint16(offset, false);
        offset += 2;

        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) {
            setOrientation((oldArray) => [...oldArray, -1]);
            return;
          }
          const little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          const tags = view.getUint16(offset, little);
          offset += 2;

          for (let i = 0; i < tags; i++) {
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              const o = view.getUint16(offset + (i * 12) + 8, little);
              setOrientation((oldArray) => [...oldArray, o]);
              return;
            }
          }
        } else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      setOrientation((oldArray) => [...oldArray, -1]);
      return;
    };

    reader.readAsArrayBuffer(singleFile.slice(0, 64 * 1024));
  };


  const handleChangeValue = (event) => {
    setForm({
      ...form,
      [event.target.name]: [event.target.value],
    });
  };

  const handleChantierChange = (chantierForm) => {
    setForm({
      ...form,
      chantier: chantierForm,
    });
  };

  const handleChangeCheckbox = (event) => {
    setForm({
      ...form,
      [event.target.name]: [event.target.checked],
    });
  };


  const handleFactureNameFormChange = (f) => {
    setForm({
      ...form,
      factureNameForm: f.value,
    });
  };

  /**
   * Permet de fermer le modal
   */
  function closeModal() {
    setWhatToShow('3');
    navigate('/chantier/' + location.state.id);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();


    const errorsForm = {};
    setErrors(errorsForm);

    if (form.file === null) {
      errorsForm.photo = 'Le média est obligatoire';
    }

    if (form.chantier === null || form.chantier.length === 0) {
      errorsForm.chantier = 'Le chantier est obligatoire';
    }

    if (Object.keys(errorsForm).length > 0) {
      setErrors(errorsForm);
    } else {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('montant', form.montant);
      formData.append('note', form.note);
      formData.append('date', form.selectedDate);
      formData.append('extra1', form.extra1);
      formData.append('extra2', form.extra2);
      formData.append('extra3', form.extra3);
      formData.append('avancement', form.avancement);
      formData.append('factureName', form.factureNameForm);
      formData.append('isfacture', 'photo');
      form.chantier.forEach((item, index) => {
        formData.append(`chantier[${index}]`, item.value);
      });

      orientation.forEach((item, index) => {
        formData.append(`orientation[${index}]`, item);
      });

      form.file.forEach((item, index) => {
        formData.append(`photo[${index}]`, item);
      });


      await api.post('/photos', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((r) =>{

        setProjectInfo((previous) => [...r.data, ...previous].sort((a, b) => {
          if (a.date < b.date) {
            return 1;
          }
          return -1;
        }));
        openModal();
      }).finally(() => {
        setWhatToShow('3');
        navigate('/chantier/' + location.state.id);
        setIsLoading(false);
      });
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}
      <AddPhotoView
        handleSubmit={handleSubmit}
        handleFileChange={handleFileChange}
        factureName={factureName}
        placeName={placeName}
        handleFactureNameFormChange={handleFactureNameFormChange}
        handleChantierChange={handleChantierChange}
        handleChantierCheckBox={handleChantierCheckBox}
        checkedChantier={props.checkedChantier}
        handleChangeValue={handleChangeValue}
        handleChangeCheckbox={handleChangeCheckbox}
        form={form}
        setForm={setForm}
        errors={errors}
        closeModal={closeModal}
      />
    </React.Fragment>
  );
}

export default AddPhoto;
